import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-content flex-col items-center justify-center px-4 py-24 text-center md:px-6">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-3xl text-primary-700">
        <i className="ri-film-line"></i>
      </span>
      <h1 className="mt-6 text-4xl font-black text-foreground-950 md:text-5xl">404</h1>
      <p className="mt-4 text-base text-foreground-600">
        这个页面可能已经被下架，或者链接有误。
      </p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/plot"
          className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
        >
          <i className="ri-book-open-line"></i>
          浏览剧情介绍
        </Link>
      </div>
    </div>
  );
}